/*jslint browser: true, fudge: true, long: true */
/*global $, blacksunplc, document, window, AOS */

blacksunplc.events.ready(function () {
    "use strict";
    var navigationWrapper = $(".main-nav");
    var interactiveMap = $(".interactive-map");
    var windowWidth = $(window).width();

    $(".hamburger").on("click", function (event) {
        event.stopPropagation();
        var button = $(event.currentTarget);
        button.addClass("is-active");
        navigationWrapper.addClass("is-active");
        $("body").addClass("menu-open");
    });

    function closeNavigation() {
        $(".hamburger").removeClass("is-active");
        navigationWrapper.removeClass("is-active");
        $("body").removeClass("menu-open");
    }

    navigationWrapper.on("click", ".main-nav__close", function (event) {
        event.preventDefault();
        closeNavigation();
    });

    navigationWrapper.on("click", function (event) {
        event.stopPropagation();
    });

    $(document).on("click", function () {
        closeNavigation();
    });

    $("body").on("click", ".interactive-map .close", function () {
        $(".scroll-icon").css("opacity", 1);
        resetMap();
    });

    if ($(".interactive-map").length) {
        if (windowWidth > 840) {
            interactiveMap.find(".item .dot").on("mouseenter", function () {
                var parentContainer = $(this).parent().parent();

                map(parentContainer);
            }).on("mouseleave", function () {

                resetMap();
            });
        } else {
            document.querySelector('.interactive-map').scrollTo(300, 0);
            interactiveMap.find(".item .dot").on("click", function () {
                var parentContainer = $(this).parent().parent();

                $(".scroll-icon").css("opacity", 0);
                map(parentContainer);
            });
        }
    }

    var parent;

    $("body").on("click", ".mobile-accordion h3", function () {
        parent = $(this).parent();
        $(this).parent().toggleClass("expand");
        $(this).parent().find(">*:not(h3)").slideToggle();

        scrollToElement(parent, 55);
        return false;
    });

    function mobileAccordion() {
        if ($(".commentary-page").length) {
            if (windowWidth > 840) {
                $(".mobile-accordion *").css("display", "");
                $(".mobile-accordion").removeClass("expand");
            }
        }
    }

    function homepage() {
        if ($(".homepage .message").length) {
            if (windowWidth > 840) {
                var titleH = 0;

                $(".homepage .message .title").each(function () {
                    $(".homepage .message .title").css("height", "");
                    if ($(this).outerHeight() > titleH) {
                        titleH = $(this).outerHeight();
                    }
                    $(".homepage .message .title").css("height", titleH);
                });
            }
        }
    }

    function progressingPage() {
        if ($(".tile-row .tile h6").length) {
            if (windowWidth > 840) {
                var titleH = 0;

                $(".tile-row .tile h6").each(function () {
                    $(".tile-row .tile h6").css("height", "");
                    if ($(this).outerHeight() > titleH) {
                        titleH = $(this).outerHeight();
                    }
                    $(".tile-row .tile h6").css("height", titleH);
                });
            }
        }
    }

    function map(item) {
        var itemPos = item.offset().left;
        var itemPosTop = item.find(".dot").offset().top;
        var itemHeight = item.outerHeight();
        var dotPos = item.find(".dot").offset().left;
        var logoPos = $(".logo-legends").offset().left;
        var logoPosTop = $(".logo-legends").offset().top;
        var line = item.find(".line");
        var bracket = line.find(".bracket");
        var lineWidth;
        var bracketWidth = 120;
        var bracketHeight = 0;
        var offset = 15;
        var country = item.find("p").text();
        var logos = item.data("logos").split(",");

        item.addClass("active");
        $(".logo-legends").addClass("active");
        interactiveMap.addClass("hover");

        for (var i = 0; i < logos.length; i++) {
            $(".logo-legends ." + logos[i]).addClass("show")
        }

        if (windowWidth > 840) {
            if (logoPos > itemPos) {
                bracket.css({
                    "left": "auto",
                    "right": 0
                });
            }

            if (item.hasClass("bottom") || item.hasClass("top")) {
                itemHeight = itemHeight - 19;
            }

            lineWidth = Math.abs(logoPos - dotPos - 20);
            line.css("width", lineWidth);

            bracketHeight = Math.abs(itemPosTop - logoPosTop - offset);

            if (itemPosTop > logoPosTop) {
                bracket.css({ "bottom": -1 });

                if (bracketHeight < 10) {
                    bracketHeight = 0;
                }
            } else {
                bracket.css({
                    "top": 0,
                    "borderTop": "none",
                    "borderBottom": "solid 1px"
                });

                if (item.hasClass("right-side")) {
                    lineWidth = lineWidth + offset;
                    bracket.css("top", 1);
                    line.css({
                        "left": lineWidth * -1,
                        "width": lineWidth
                    });

                    bracketWidth = 20;
                }
            }

            bracket.css({
                "height": bracketHeight,
                "width": bracketWidth
            });


            if (item.hasClass("right") && !item.hasClass("top")) {
                bracket.css({
                    "right": "auto",
                    "top": 0,
                });

                line.css({
                    "height": bracketHeight,
                    "top": 0,
                    "width": (lineWidth - 5),
                    "left": 5
                });
            }
        } else {
            $(".logo-legends .top-bar p").remove();
            $(".logo-legends .top-bar").prepend("<p>" + country + "</p>");
        }
    }

    function resetMap() {

        interactiveMap.removeClass("hover");
        interactiveMap.find(".item").removeClass("active");
        $(".logo-legends").removeClass("active");
        $(".logo-legends *").removeClass("show");

        $(".interactive-map .item").each(function () {
            $(this).find(".line, .bracket").attr("style", "");
        });

        $(".logo-legends .top-bar p").remove();
    }

    function scrollToElement(element, topSpacing) {
        $("html, body").animate({
            scrollTop: element.offset().top - topSpacing
        }, 500);
    }

    function gotoSectionNavigaion() {
        $(".page-body__navigation").on("click", "a", function (event) {
            event.preventDefault();
            var anchore = $(event.currentTarget);
            var id = anchore.attr("href");
            if ($(id).parents(".bs-accordion").length) {
                var accButton = id.replace("#", "");
                var button = $(".bs-accordion__header button[aria-controls=" + accButton + "]");
                button.trigger("click");
                setTimeout(function () {
                    scrollToElement(button, 70);
                }, 300);
            } else {
                scrollToElement($(id), 100);
            }
        });
    }

    function resizeGallery() {
        if (windowWidth > 820) {
            $(".pillar__gallery").each(function () {
                var titleHeight = 0;
                var outerHeight = 0;

                $(this).find("h6").each(function () {
                    outerHeight = $(this).outerHeight();
                    if (outerHeight > titleHeight) {
                        titleHeight = outerHeight;
                    }
                });

                $(this).find("h6").css("height", titleHeight + "px");
            });
        }
    }

    function resizeGalleryImage() {
        if (windowWidth > 820) {
            $(".pillar__gallery").each(function () {
                var imgHeight = 0;
                var outerImageHeight = 0;

                $(this).find(".img-container").each(function () {
                    outerImageHeight = $(this).outerHeight();

                    if (outerImageHeight > imgHeight) {
                        imgHeight = outerImageHeight;
                    }
                });

                $(this).find(".img-container").css("height", imgHeight + "px");
            });
        }
    }

    function dividendCart() {
        if (windowWidth > 820) {
            var itemHeight = 0;
            $(".dividends-chart .item li").each(function () {

                var outerHeight = $(this).outerHeight();
                if (outerHeight > itemHeight) {
                    itemHeight = outerHeight;
                }

            });
            $(".dividends-chart .item li").css("height", itemHeight + "px");
        }
    }

    function resizeNumericValues() {
        if ($(".numeric-values .flex").length > 0) {
            var contHeight = 0;
            var parent;
            var firstChild;
            if (windowWidth > 767) {
                $(".numeric-values .flex").each(function () {
                    contHeight = 0;
                    parent = $(this);
                    firstChild = parent.find(".value-item:first-child");

                    firstChild.css("height", "");
                    firstChild.each(function () {
                        if ($(this).outerHeight() > contHeight) {
                            firstChild.height($(this).outerHeight() + "px");
                        }
                    });
                });
            } else {
                $(".numeric-values .flex .value-item").css("height", "");
            }
        }
    }

    function sustainabilityTables() {
        if (windowWidth > 840) {
            var headingHeight = 0;
            var headingHeightSus = 0;

            $(".sustainable-table .red-bg").css("height", "");
            $(".sustainability-table .heading").css("height", "");

            $(".sustainable-table .red-bg").each(function () {
                if ($(this).outerHeight() > headingHeight) {
                    headingHeight = $(this).outerHeight();
                }
            });
            $(".sustainability-table .heading").each(function () {
                if ($(this).outerHeight() > headingHeightSus) {
                    headingHeightSus = $(this).outerHeight();
                }
            });

            $(".sustainable-table .red-bg").css("height", headingHeight);
            $(".sustainability-table .heading").css("height", headingHeightSus);
        }
    }

    resizeNumericValues();
    resizeGallery();
    dividendCart();
    gotoSectionNavigaion();
    homepage();
    sustainabilityTables();
    mobileAccordion();


    $(window).on('resize', function () {
        sustainabilityTables();
        mobileAccordion();
        homepage();
        progressingPage();
    });

    setTimeout(function () {
        homepage();
        resizeGalleryImage();
        progressingPage();
    }, 1000);
});
